import { getTableColumn } from '@shared/UI';
import moment from 'moment';
import { getResultWithIcon } from './getResultWithIcon';

export function getKYCTableColumns() {
    return [
        getTableColumn({
            dataField: 'verificationDate',
            title: 'Date',
            firstColumn: true,
            formatter: (cell) => `${moment(cell).format('MMM D, YYYY HH:mm')}`,
        }),
        getTableColumn({
            dataField: 'result',
            className: (cell) => cell,
            formatter: (cell) => getResultWithIcon(cell),
        }),
    ];
}
